import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cc4794a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "col scroll dialog-content",
  style: 'min-height: 100px;'
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "full-width": _ctx.$q.screen.lt.md,
    maximized: _ctx.$q.screen.lt.md,
    persistent: _ctx.persistent,
    position: _ctx.positionValue,
    onHide: _ctx.onHide,
    ref: "dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        style: _normalizeStyle(`width: ${_ctx.formWidth}px; max-width: 80vw;`)
      }, [
        _createVNode(_component_q_card, { class: "bordered shadow-3 dialog-height column no-wrap" }, {
          default: _withCtx(() => [
            (!_ctx.hideHeader)
              ? (_openBlock(), _createBlock(_component_q_card_actions, {
                  key: 0,
                  align: "between",
                  class: "no-wrap q-px-lg q-pt-md"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, _mergeProps(_ctx.titleProps || _ctx.TEXT_SECONDARY_TITLE, {
                      class: ["break-word", { ellipsis: !_ctx.titleNotEllipsed }]
                    }), {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.title), 1)
                      ]),
                      _: 1
                    }, 16, ["class"]),
                    (_ctx.labelTooltip)
                      ? (_openBlock(), _createBlock(_component_q_tooltip, _normalizeProps(_mergeProps({ key: 0 }, _ctx.TOOLTIP_PROPS)), {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.labelTooltip), 1)
                          ]),
                          _: 1
                        }, 16))
                      : _createCommentVNode("", true),
                    _withDirectives((_openBlock(), _createBlock(_component_q_btn, _mergeProps({ class: "q-mr-xs" }, _ctx.BTN_TERTIARY_LG, { onClick: _ctx.onHide }), {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: _ctx.ICONS_NAME.TIMES_SOLID,
                          color: "grey-dark"
                        }, null, 8, ["name"])
                      ]),
                      _: 1
                    }, 16, ["onClick"])), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.hideHeader)
              ? (_openBlock(), _createBlock(_component_q_separator, {
                  key: 1,
                  class: "q-mx-lg",
                  color: "grey-light"
                }))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "before-content", {}, undefined, true),
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "content", {}, undefined, true)
            ]),
            _renderSlot(_ctx.$slots, "after-content", {}, undefined, true),
            (!_ctx.noSlotAfter)
              ? _renderSlot(_ctx.$slots, "after", { key: 2 }, () => [
                  _createVNode(_component_q_separator),
                  _createVNode(_component_q_card_actions, {
                    align: _ctx.afterActionsAlign,
                    class: "bg-grey-lighter q-px-lg q-py-md"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_q_btn, _mergeProps({
                        disable: _ctx.disableCancelBtn,
                        label: _ctx.cancelLabelValue,
                        onClick: _ctx.cancel
                      }, _ctx.BTN_SECONDARY_LG), null, 16, ["disable", "label", "onClick"]), [
                        [_vShow, !_ctx.hideCancel]
                      ]),
                      _createElementVNode("span", null, [
                        (_ctx.secondaryLabel)
                          ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
                              key: 0,
                              onClick: _ctx.secondary,
                              disable: _ctx.disableSecondary,
                              class: { 'q-mr-md': !_ctx.noConfirm },
                              label: _ctx.secondaryLabel
                            }, _ctx.BTN_SECONDARY_LG), null, 16, ["onClick", "disable", "class", "label"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, [
                          (!_ctx.noConfirm)
                            ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
                                key: 0,
                                disable: _ctx.disableConfirmBtn,
                                label: _ctx.confirmLabelValue,
                                loading: _ctx.loading,
                                onClick: _ctx.confirm
                              }, _ctx.confirmBtnStyle), null, 16, ["disable", "label", "loading", "onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.confirmTooltip)
                            ? (_openBlock(), _createBlock(_component_q_tooltip, _normalizeProps(_mergeProps({ key: 1 }, _ctx.TOOLTIP_PROPS)), {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.confirmTooltip), 1)
                                ]),
                                _: 1
                              }, 16))
                            : _createCommentVNode("", true),
                          (_ctx.disableConfirmMessage)
                            ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 2 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.disableConfirmMessage), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["align"])
                ], true)
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ], 4)
    ]),
    _: 3
  }, 8, ["full-width", "maximized", "persistent", "position", "onHide"]))
}